/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CargCsclPrgsInfoQryRtnVo } from './CargCsclPrgsInfoQryRtnVo';
import {
    CargCsclPrgsInfoQryRtnVoFromJSON,
    CargCsclPrgsInfoQryRtnVoFromJSONTyped,
    CargCsclPrgsInfoQryRtnVoToJSON,
    CargCsclPrgsInfoQryRtnVoToJSONTyped,
} from './CargCsclPrgsInfoQryRtnVo';

/**
 * 
 * @export
 * @interface ResponseCargCsclPrgsInfoQryRtnVo
 */
export interface ResponseCargCsclPrgsInfoQryRtnVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseCargCsclPrgsInfoQryRtnVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseCargCsclPrgsInfoQryRtnVo
     */
    message?: string;
    /**
     * 
     * @type {CargCsclPrgsInfoQryRtnVo}
     * @memberof ResponseCargCsclPrgsInfoQryRtnVo
     */
    data?: CargCsclPrgsInfoQryRtnVo;
}

/**
 * Check if a given object implements the ResponseCargCsclPrgsInfoQryRtnVo interface.
 */
export function instanceOfResponseCargCsclPrgsInfoQryRtnVo(value: object): value is ResponseCargCsclPrgsInfoQryRtnVo {
    return true;
}

export function ResponseCargCsclPrgsInfoQryRtnVoFromJSON(json: any): ResponseCargCsclPrgsInfoQryRtnVo {
    return ResponseCargCsclPrgsInfoQryRtnVoFromJSONTyped(json, false);
}

export function ResponseCargCsclPrgsInfoQryRtnVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseCargCsclPrgsInfoQryRtnVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : CargCsclPrgsInfoQryRtnVoFromJSON(json['data']),
    };
}

export function ResponseCargCsclPrgsInfoQryRtnVoToJSON(json: any): ResponseCargCsclPrgsInfoQryRtnVo {
    return ResponseCargCsclPrgsInfoQryRtnVoToJSONTyped(json, false);
}

export function ResponseCargCsclPrgsInfoQryRtnVoToJSONTyped(value?: ResponseCargCsclPrgsInfoQryRtnVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': CargCsclPrgsInfoQryRtnVoToJSON(value['data']),
    };
}

